import { createArchiveController } from '../../external/archive-widget/controller';

export default createArchiveController;
